import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

import ValidationAlert from '../../../app/components/ValidationAlert';
import { CreateUpdateJobConfigDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import LastEditorInfo from '../../../app/components/LastEditorInfo';
import { useSpdCore } from '../../../common/hooks/useSpdCore';

import { JobConfigFrom } from './JobConfigForm';

interface JobConfigEditorProps {
  id?: string;
  systemNumber?: number;
  jobConfig: CreateUpdateJobConfigDto;
  handleClose?: () => void;
  show?: boolean;
  onCompleted: (
    jobConfig: CreateUpdateJobConfigDto,
    id?: string,
  ) => Promise<{
    saved: boolean;
    errors: string[];
  }>;
  readOnly: boolean;
}

export const JobConfigEditor: React.FC<JobConfigEditorProps> = props => {
  const [jobConfig, setJobConfig] = useState(props.jobConfig);
  const [show, setShow] = useState(props.show || false);
  const [showSaveErrors, setShowSaveErrors] = useState(false);
  const [saveErrors, setSaveErrors] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const spd = useSpdCore();
  const createJobConfig = async () => {
    setIsLoading(true);
    props
      .onCompleted(jobConfig, props.id)
      .then(saveStatus => {
        if (!saveStatus.saved) {
          setSaveErrors(saveStatus.errors);
          setShowSaveErrors(true);
          return;
        }
        // notifications.saveCompleted();
        handleClose();
      })
      .catch(errorResponse => {
        console.error(errorResponse);
      })
      .finally(() => setIsLoading(false));
  };

  const createErrors = (errors: string[]) => {
    setSaveErrors(errors);
    setShowSaveErrors(!!errors.length);
  };

  const propertyChange = (obj: Partial<CreateUpdateJobConfigDto>) => {
    setJobConfig({ ...jobConfig, ...obj });
  };

  useEffect(() => {
    if (props.show) {
      setSaveErrors([]);
      setShowSaveErrors(false);
      setJobConfig(props.jobConfig);
      setShow(true);
    }
  }, [props.jobConfig, props.show]);

  const handleClose = () => {
    setShow(false);
    if (props.handleClose) {
      props.handleClose();
    }
  };

  return (
    <Modal
      onHide={handleClose}
      show={show}
      centered={true}
      keyboard={true}
      backdrop="static"
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {props.id
            ? `Edycja zadania cyklicznego: ${props.systemNumber}`
            : 'Dodawanie zadania cyklicznego'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <JobConfigFrom
          jobConfig={jobConfig}
          readOnly={props.readOnly}
          propertyChange={propertyChange}
          createErrors={createErrors}
        />
        <ValidationAlert
          show={showSaveErrors}
          errors={saveErrors}
          className="m-3"
        />
      </Modal.Body>
      <Modal.Footer>
        {props.id && (
          <LastEditorInfo id={props.id} method={spd.jobConfig.getLastEditor} />
        )}
        <Button
          variant="outline-secondary"
          onClick={handleClose}
          disabled={isLoading}
        >
          Zamknij
        </Button>
        <Button variant="primary" onClick={createJobConfig}>
          Zapisz
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
